module.exports = __webpack_public_path__ + "static/media/ic-get-feedback.d5c9f3ea.svg";